import {createSelector} from 'reselect';
// @ts-ignore
import * as ramda from 'ramda';

import type {CoreEntityType, SavedFilterId, SavedFilter, SavedListType} from '../types';
import type {SavedFiltersModuleState} from './saved-filters-reducer';
import {
    isSavedReport,
    isSavedList,
    getSavedListReportTypeFromEntityType,
} from './saved-filters-utils';

export const getSavedFiltersState = (state: SavedFiltersModuleState) => state.savedFilters;

export const getSavedFilters = createSelector([getSavedFiltersState], (savedFiltersState) => {
    return savedFiltersState.items;
});

export const getSavedReports = createSelector([getSavedFilters], (savedFilters) => {
    return ramda.filter(isSavedReport, savedFilters);
});

export const getSavedLists = createSelector([getSavedFilters], (savedFilters) => {
    return ramda.filter(isSavedList, savedFilters);
});

// TODO: memoize this
export const getSavedListsForEntityType = (
    entityType: CoreEntityType,
    state: SavedFiltersModuleState
): SavedFilter<SavedListType>[] => {
    const reportType = getSavedListReportTypeFromEntityType(entityType);

    return (
        ramda
            .values<Partial<Record<SavedFilterId, SavedFilter<any>>>>(getSavedLists(state))
            // @ts-ignore
            .filter((list) => list.reportType === reportType)
    );
};

export const getLoadingErrorMessage = createSelector(
    [getSavedFiltersState],
    (savedFiltersState) => {
        return savedFiltersState.loadingErrorMessage;
    }
);

export const getActionErrorMessage = createSelector([getSavedFiltersState], (savedFiltersState) => {
    return savedFiltersState.actionErrorMessage;
});

export const getIsLoading = createSelector([getSavedFiltersState], (savedFiltersState) => {
    return savedFiltersState.isLoading;
});

export const getIsSavingNew = createSelector([getSavedFiltersState], (savedFiltersState) => {
    return savedFiltersState.isSavingNew;
});

export const getIsResaving = createSelector([getSavedFiltersState], (savedFiltersState) => {
    return savedFiltersState.isResaving;
});

export const getIsSavingSharePreferences = createSelector(
    [getSavedFiltersState],
    (savedFiltersState) => {
        return savedFiltersState.isSavingSharePreferences;
    }
);
